module.exports = __webpack_public_path__ + "static/media/webIconDark.c261ddfd.svg";